import React from "react";
import "./style.css";

export default function RotateDeviceGraphic() {
  return (
    <div className="pi-rotate-device-graphic" aria-hidden="true">
      <div className="pi-rotate-device-graphic__glow" />
      <svg
        className="pi-rotate-device-graphic__svg"
        viewBox="0 0 280 200"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        role="img"
        aria-label=""
      >
        <defs>
          <linearGradient id="pi-rotate-phone" x1="112" y1="44" x2="168" y2="156" gradientUnits="userSpaceOnUse">
            <stop stopColor="#1e40af" />
            <stop offset="1" stopColor="#2563eb" />
          </linearGradient>
          <linearGradient id="pi-rotate-screen" x1="120" y1="56" x2="160" y2="144" gradientUnits="userSpaceOnUse">
            <stop stopColor="#dbeafe" />
            <stop offset="1" stopColor="#eff6ff" />
          </linearGradient>
        </defs>

        <rect
          className="pi-rotate-device-graphic__guide"
          x="48"
          y="72"
          width="184"
          height="104"
          rx="14"
          stroke="#94a3b8"
          strokeWidth="2"
          strokeDasharray="8 7"
          fill="rgba(148, 163, 184, 0.06)"
        />
        <text
          className="pi-rotate-device-graphic__guide-label"
          x="140"
          y="188"
          textAnchor="middle"
        >
          Landscape
        </text>

        <path
          className="pi-rotate-device-graphic__arc"
          d="M196 52a52 52 0 0 0-92 28"
          stroke="#2563eb"
          strokeWidth="2.25"
          strokeLinecap="round"
          strokeDasharray="6 8"
        />
        <path
          className="pi-rotate-device-graphic__arc-head"
          d="M108 78l-6 8 10 2"
          stroke="#2563eb"
          strokeWidth="2.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />

        <g className="pi-rotate-device-graphic__phone-group">
          <rect x="112" y="44" width="56" height="112" rx="12" fill="url(#pi-rotate-phone)" />
          <rect x="120" y="56" width="40" height="88" rx="5" fill="url(#pi-rotate-screen)" />
          <rect x="128" y="50" width="24" height="4" rx="2" fill="rgba(255,255,255,0.35)" />
          <circle cx="140" cy="150" r="4" fill="#dbeafe" />
          <rect x="126" y="78" width="28" height="44" rx="4" fill="rgba(37, 99, 235, 0.1)" stroke="#93c5fd" strokeWidth="1.25" />
          <circle cx="140" cy="100" r="10" stroke="#2563eb" strokeWidth="1.75" fill="rgba(37, 99, 235, 0.15)" />
          <circle cx="140" cy="100" r="4" fill="#2563eb" className="pi-rotate-device-graphic__lens" />
        </g>
      </svg>
    </div>
  );
}
